import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import BoatIcon from './boat.svg'
import PlaneIcon from './plane-18.svg'
import capitalize from 'lodash/capitalize'
import { Image } from '@deal/components'
import { Link } from 'react-router-dom'
import {
  ExpertCuratedOrderListActivationComponent,
  MessageRichCardType
} from '#src/generated/graphql'
import styles from './styles.css'

export default class ServiceCuration extends Component<MessageComponentProps> {
  public static handlesMessage(message: FirebaseMessage) {
    return (
      message.parts[0].type == 'TEMPLATE_CAROUSEL' &&
      (message.parts[0].body.type === 'new-expert-curated-order-list' ||
        message.parts[0].body.richCardType === MessageRichCardType.NEW_EXPERT_CURATED_ORDER_LIST) &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.expertCuratedOrderListActivationId
    )
  }

  public render() {
    const expertCuratedOrderListActivationId = this.props.message.parts[0].body.queryVariables
      .expertCuratedOrderListActivationId

    return (
      <ExpertCuratedOrderListActivationComponent
        variables={{ id: expertCuratedOrderListActivationId }}
      >
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.expertCuratedOrderListActivation) {
            const { active, lead } = data.expertCuratedOrderListActivation

            const expertName = lead.expert.firstName
              ? capitalize(lead.expert.firstName)
              : 'Your expert'
            const itemCount = active.length

            const category = data.expertCuratedOrderListActivation.lead.category
            const banner =
              category &&
              category.contentAssets.bannerImages &&
              category.contentAssets.bannerImages[0]

            const isYacht = category && category.slug === 'charters'

            const headline = isYacht
              ? `${expertName}'s Yacht Charter`
              : `${expertName}'s Flight Plan`

            const subhead = isYacht ? (
              <>
                <BoatIcon className={styles.curationIcon} /> {itemCount} boat and itinerary{' '}
                {itemCount === 1 ? 'option' : 'options'}{' '}
              </>
            ) : (
              <>
                <PlaneIcon className={styles.curationIcon} />
                {itemCount} travel {itemCount === 1 ? 'option' : 'options'}{' '}
              </>
            )

            const cta = isYacht
              ? `View ${itemCount > 1 ? 'Charters' : 'Charter'}`
              : `View ${itemCount > 1 ? 'Flights' : 'Flight'}`

            return (
              <MessageBubble message={this.props.message}>
                <div className={styles.hero}>
                  {banner &&
                    banner.imageUrl && (
                      <Image
                        src={banner.imageUrl}
                        width={384}
                        height={134}
                        imgixParams={{ fit: 'crop' }}
                        className={styles.heroImage}
                      />
                    )}
                  <div className={styles.title}>{headline}</div>
                </div>

                <div className={styles.caption}>{subhead}</div>

                <Link to={`/curations/experiences/review/${lead.id}`} className={styles.cta}>
                  {cta}
                </Link>
              </MessageBubble>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading messages!
              </MessageBubbleText>
            )
          }
        }}
      </ExpertCuratedOrderListActivationComponent>
    )
  }
}
